import { Themes } from '../../constants/Enums';

/**
 * Maps legacy user theme preference to design-system light/dark mode.
 * Custom and github-dark use the dark DS palette; legacy inline overrides still apply.
 */
const resolveDsTheme = (theme) => {
  if (theme === Themes.LIGHT) {
    return 'light';
  }

  return 'dark';
};

export default resolveDsTheme;
